export const SAVE_POST_DRAFT_REQUEST = 'post/SAVE_DRAFT_REQUEST';
export const SAVE_POST_DRAFT_SUCCESS = 'post/SAVE_DRAFT_SUCCESS';
export const SAVE_POST_DRAFT_FAILURE = 'post/SAVE_DRAFT_FAILURE';
export const STOP_LOADING_DEBOUNCED = 'post/STOP_LOADING_DEBOUNCED';
